import { API_PROXY_BASE, API_PROXY_HEADER, API_PROXY_HEADER_VALUE } from '#shared/utils/api-proxy'
import { defineStore } from 'pinia'

export const useProfileStore = defineStore('profile', () => {
  const state = ref({
    id: null,
    name: '',
    email: '',
    status: '',
    roles: [],
    phoneNumber: '',
    autoValidateSales: false
  })

  const getId = computed(() => {
    return state.value.id
  })

  const getName = computed(() => {
    return state.value.name
  })

  const getEmail = computed(() => {
    return state.value.email
  })

  const hasPhoneNumber = computed(() => {
    return !!state.value.phoneNumber
  })

  const getProfile = computed(() => {
    return {
      id: state.value.id,
      name: state.value.name,
      email: state.value.email,
      status: state.value.status,
      roles: state.value.roles,
      phoneNumber: state.value.phoneNumber,
      autoValidateSales: state.value.autoValidateSales
    }
  })

  function setProfile (profile) {
    state.value.id = profile.id
    state.value.name = profile.name
    state.value.email = profile.email
    state.value.status = profile.status
    state.value.roles = profile.roles
    state.value.phoneNumber = profile.phoneNumber
    state.value.autoValidateSales = profile.autoValidateSales
  }

  function clearProfile () {
    state.value.id = null
    state.value.name = ''
    state.value.email = ''
    state.value.status = ''
    state.value.roles = []
    state.value.phoneNumber = ''
    state.value.autoValidateSales = false
  }

  async function loadProfile (userId, callback) {
    // Not useApi: this runs while useAuth is still being set up
    const profile = await $fetch('/users/' + userId, {
      baseURL: API_PROXY_BASE,
      headers: {
        Accept: 'application/json, application/problem+json',
        [API_PROXY_HEADER]: API_PROXY_HEADER_VALUE
      }
    })
    setProfile(profile)

    if (callback) {
      const { isValidator } = useAuth()
      callback(isValidator)
    }

    return profile
  }

  return {
    state,
    getId,
    getName,
    getEmail,
    hasPhoneNumber,
    getProfile,
    setProfile,
    clearProfile,
    loadProfile
  }
})
